import React, { FC, useState } from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { Wrapper } from "../styled";
import AppointmentMovement from "./tabs/AppointmentMovement";

const AppointmentMovementsTabs = [
{
    title: "Назначения, перемещения",
    component: <AppointmentMovement/>,
}
];

const AppointmentsMovements: FC = () => {
const [tab, setTab] = useState(0);

const handleChangeTab = (event: React.SyntheticEvent, newValue: number) => {
    setTab(newValue);
};

return (
    <Wrapper>
    <Tabs
        value={tab}
        onChange={handleChangeTab}
        variant="scrollable"
        scrollButtons="auto"
        aria-label="scrollable auto tabs example"
    >
        {AppointmentMovementsTabs.map((tab) => (
        <Tab key={tab.title} label={tab.title} />
        ))}
    </Tabs>
    {AppointmentMovementsTabs[tab].component}
    </Wrapper>
);
};

export default AppointmentsMovements;
